import { ApiBaseFront } from "../api-base-front";

type Params = {
  kijshopCd: string,
  shopOrderId: string,
  // 再発注フラグ
  isReRequest: number,
  debug: 0 | 1 | 2,
  // バックエンドラボ発注を意図的に失敗させたい時は1
  errorKind: 0 | 1,
  isCompImageOrder?: 0 | 1,
};

export class ApiLabOrderAlignment extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      shopOrderId,
      ...defaultProps
    } = param;

    super(
      'POST',
      `/api/v1/request/${kijshopCd}/${shopOrderId}/orderAlignment`,
      'JSON',
      defaultProps,
    );
  }
}
export class ApiStandardLabOrderAlignment extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      shopOrderId,
      ...defaultProps
    } = param;
    super(
      'POST',
      `/api/v1/request/${kijshopCd}/${shopOrderId}/ppmOrderAlignment`,
      'JSON',
      defaultProps,
    );
  }
}
